import { useState } from 'react';
import { alpha } from '@material-ui/core/styles/colorManipulator';
import { makeStyles } from '@material-ui/core/styles';
import {
    useUpdateMany,
    useRefresh,
    useNotify,
    useUnselectAll,
    CRUD_UPDATE_MANY,
    useResourceContext,
    useListContext,
} from 'ra-core';
import { AutocompleteInput, Button, required, useTranslate } from 'react-admin';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button as UIButton } from '@material-ui/core';
import { getOffersStatuses } from './OffersTypes';
import { Cached } from '@material-ui/icons';
import { Form } from 'react-final-form'

const offersStatuses = getOffersStatuses()


const useStyles = makeStyles(
    theme => ({
        updateButton: {
            color: theme.palette.error.main,
            '&:hover': {
                backgroundColor: alpha(theme.palette.error.main, 0.12),
                // Reset on mouse devices
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
        },
    }),
    { name: 'RaBulkUpdateWithUndoButton' }
);


const BulkUpdateWithUndoButton = (props: any) => {
    const { selectedIds } = useListContext(props);
    const classes = useStyles(props);
    const notify = useNotify();
    const unselectAll = useUnselectAll();
    const refresh = useRefresh();
    const resource = useResourceContext(props);

    const translate = useTranslate()
    const [value, setValue] = useState<{ name: string, id: string }>({ id: '', name: '' });
    const [open, setOpen] = useState(false);

    const {
        basePath,
        classes: classesOverride,
        data,
        onClick,
        onSuccess = () => {
            notify(
                'ra.notification.updated',
                'info',
                { smart_count: selectedIds.length },
                true
            );
            unselectAll(resource);
            refresh();
        },
        onFailure = (error: any) => {
            notify(
                typeof error === 'string'
                    ? error
                    : error.message || 'ra.notification.http_error',
                'warning',
                {
                    _:
                        typeof error === 'string'
                            ? error
                            : error && error.message
                                ? error.message
                                : undefined,
                }
            );
            refresh();
        },
        ...rest
    } = props;

    const [updateMany, { loading }] = useUpdateMany(
        resource,
        selectedIds,
        { status: value.id },
        {
            action: CRUD_UPDATE_MANY,
            onSuccess,
            onFailure,
            undoable: true,
        }
    );

    const handleSubmit = (e: any) => {
        updateMany();
        if (typeof onClick === 'function') {
            onClick(e);
        }
        handleClose()
    };

    const updateValue = (value: any) => {
        // console.log(value)
        setValue(value)
    }
    const handleClose = () => {
        setOpen(false);
    };

    const handleClick = () => {
        setOpen(true)
    }

    return (<>

        <Dialog open={open} onClose={handleClose}>
            <DialogTitle id="max-width-dialog-title">{translate("resources.offers.bulkChangeStatus.title")}</DialogTitle>

            <Form onSubmit={handleSubmit}>
                {props => (
                    <form onSubmit={props.handleSubmit}>
                        <DialogContent>
                            <AutocompleteInput
                                source="status"
                                choices={offersStatuses}
                                onSelect={updateValue}
                                resettable
                                options={{
                                    InputProps: {
                                        name: 'max-width',
                                        id: 'max-width',
                                        // autoFocus: true,
                                    }
                                }}
                                fullWidth
                                validate={[required()]}
                            />
                        </DialogContent>
                        <DialogActions>
                            <UIButton onClick={handleClose}>{translate("pos.cancel")}</UIButton>
                            <UIButton type="submit" >{translate("pos.save")}</UIButton>
                        </DialogActions>
                    </form>
                )}
            </Form>
        </Dialog>
        <Button
            onClick={handleClick}
            label={translate("resources.offers.bulkChangeStatus.label")}
            className={classes.updateButton}
            disabled={loading}
            {...rest}
        >
            <Cached />
        </Button>
    </>);
};

export default BulkUpdateWithUndoButton